import { render, staticRenderFns } from "./FullEventSlide.vue?vue&type=template&id=781c889e&scoped=true&"
import script from "./FullEventSlide.vue?vue&type=script&lang=ts&"
export * from "./FullEventSlide.vue?vue&type=script&lang=ts&"
import style0 from "./FullEventSlide.vue?vue&type=style&index=0&id=781c889e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781c889e",
  null
  
)

export default component.exports